import { render, staticRenderFns } from "./DbInfiniteScroll.vue?vue&type=template&id=640f0f22&scoped=true&"
import script from "./DbInfiniteScroll.vue?vue&type=script&lang=ts&"
export * from "./DbInfiniteScroll.vue?vue&type=script&lang=ts&"
import style0 from "./DbInfiniteScroll.vue?vue&type=style&index=0&id=640f0f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f0f22",
  null
  
)

export default component.exports